import { bidTypes } from 'constants/bid'
import { auth, db } from 'data/firebase'
import { collection, query, where, limit, orderBy } from 'firebase/firestore'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useCollectionData } from 'react-firebase-hooks/firestore'

export const useMyLastLiveBid = (auctionId, itemId) => {
  const [user] = useAuthState(auth)
  const [[bid] = [], bidLoading] = useCollectionData(
    user?.uid
      ? query(
          collection(db, `auctions/${auctionId}/products/${itemId}/bids`),
          where('userId', '==', user.uid),
          where('type', '==', bidTypes.LIVE),
          orderBy('amount', 'desc'),
          orderBy('date', 'desc'),
          limit(1)
        )
      : undefined
  )

  return { bid, loading: bidLoading }
}
